<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
html,
body,
#app {
  height: 100%;
  background: transparent;
}

body {
  height: 100vh;
  margin: 0;
}
</style>
